import { FC, useMemo, useState } from "react";

import "./VariantGroupNew.css";
import { FormElement } from "../../Components/FormElement/FormElement";
import { TextInput } from "../../Components/TextInput/TextInput";
import {
  useCreateVariantGroupMutation,
  useVariantGroupNewQuery,
} from "../../Generated/graphql";
import { Select, SelectOption } from "../../Components/Select/Select";
import { isString } from "lodash";
import { Button } from "../../Components/Button/Button";
import { useHistory } from "react-router-dom";

export const VariantGroupNew: FC<{}> = () => {
  const history = useHistory();

  const { data } = useVariantGroupNewQuery();

  const [createVariantGroup] = useCreateVariantGroupMutation();

  const [name, setName] = useState("");
  const [productLevelAId, setProductLevelAId] = useState("");
  const [categoryB, setCategoryB] = useState("");

  // Validate the form
  const isFormValid = useMemo(() => {
    const nameIsLongEnough = name.length > 3;

    const productLevelAIsSelected = productLevelAId.length > 0;

    const categoryBIsSelected = categoryB.length > 0;

    return nameIsLongEnough && productLevelAIsSelected && categoryBIsSelected;
  }, [name.length, productLevelAId.length, categoryB.length]);

  // Construct data for the category selector
  const categoryBLevels = useMemo(() => {
    if (!data) {
      return [];
    }

    return (
      data.categories
        // Since GraphQL returns null values, we need to filter them out
        .filter(isString)
        // Format as SelectOptions
        .map((category) => ({
          label: category,
          key: category,
          value: category,
        }))
    );
  }, [data]);

  const handleSave = async () => {
    const result = await createVariantGroup({
      variables: {
        name,
        productLevelAId,
        category: categoryB,
      },
    });

    const newGroupId = result.data?.createVariantGroup?.id;

    if (newGroupId) {
      history.push(`/main/edit/group/${newGroupId}`);
    }
  };

  return (
    <div className="VariantGroupNew">
      <div className="VariantGroupNew__Form">
        <div className="VariantGroupNew__Headline">Opret variantgruppe</div>
        <FormElement label="Navn">
          <TextInput
            placeholder="Navn på produktgruppen"
            value={name}
            change={(e) => setName(e.target.value)}
          />
        </FormElement>
        <FormElement label="Kategori niveau A">
          <Select
            defaultText="Vælg en kategori"
            change={(v) => {
              setProductLevelAId(v);
            }}
            value={productLevelAId}
            type="default"
          >
            {data?.productLevelALevels.map(({ id, name }) => (
              <SelectOption key={id} value={id}>
                {name}
              </SelectOption>
            ))}
          </Select>
        </FormElement>

        <FormElement label="Kategori niveau B">
          <Select
            defaultText="Vælg en kategori"
            change={(v) => {
              setCategoryB(v);
            }}
            value={categoryB}
            type="default"
            showFilter
          >
            {categoryBLevels.map(({ key, label, value }) => (
              <SelectOption key={key} value={value}>
                {label}
              </SelectOption>
            ))}
          </Select>
        </FormElement>
        <div className="VariantGroupNew__Button">
          <Button
            buttonStyling="save"
            label="Opret variantgruppe"
            click={() => isFormValid && handleSave()}
            active={isFormValid}
          />
        </div>
      </div>
    </div>
  );
};
